import { ReactNode } from 'react';

import { Tooltip } from '@mui/material';

import { Icon, IconColor, IconSize } from '../Icon';
import styles from './InfoIconWithTooltip.module.scss';
import { uiIcons } from '@/constants/uiIcons';

interface InfoIconWithTooltipProps {
  id: string;
  tooltip: ReactNode;
  size?: IconSize;
  color?: IconColor;
}
export const InfoIconWithTooltip = ({
  id,
  tooltip,
  size = 'micro',
  color = 'secondary',
}: InfoIconWithTooltipProps) => {
  return (
    <Tooltip id={id} title={tooltip} arrow>
      <div className={styles.IconWrapper}>
        <Icon name={uiIcons.status.info} size={size} color={color} />
      </div>
    </Tooltip>
  );
};
